const blank = "https://www.movedemocracy.org/wp-content/uploads/2022/09/headshot-placeholder.png"

export const officers = [
    {
        name: "Patricia Alfonso",
        position: "President",
        major: "Computer Science",
        photo: require("../images/hack25/committee/patricia.jpg")
    },
    {
        name: "Aaron Cayanan",
        position: "Executive Vice President",
        email: "",
        major: "",
        photo: blank,
    },
    {
        name: "Sakshi Bharambe",
        position: "Vice President of Finance",
        email: "",
        major: "",
        photo: blank,
    },
    {
        name: "Rhea Shenoy",
        position: "Vice President of Inter-Club Affairs",
        email: "",
        major: "",
        photo: blank,
    },
    {
        name: "Meghna Manoj",
        position: "Vice President of Marketing",
        email: "",
        major: "",
        photo: blank,
    },
    {
        name: "Mathew Hernandez",
        position: "Secretary",
        email: "",
        major: "",
        photo: blank,
    },
    {
        name: "Shelvy Millado",
        position: "Deputy Officer",
        email: "",
        major: "Computer Science",
        photo: require("../images/officers25/shelvy.png"),
    },
    {
        name: "Joann Chen",
        position: "Faculty Advisor",
        email: "jchen27@sdsu.edu",
        url: "https://joannqc.com/",
        major: "Professor of Computer Science",
        photo: require("../images/officers25/chen.png")
    },
]